module.exports = __webpack_public_path__ + "img/icon_map_1_c.1df1f336.png";